/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MilestoneDocumentUploadMessageCard = ({ data, index, milestoneData }) => {
  const [{ LoginData }] = useSelector((state) => [state.user]);
  const sender = data?.senderId === LoginData?.uuid;
  const navigate = useNavigate();

  const reDirect = () => {
    if (LoginData.isCustomer) {
      navigate(`/dashboard/projects/${milestoneData?.job_uuid}`);
    } else {
      navigate(`/dashboard/jobs/${milestoneData?.job_uuid}`);
    }
  };
  return (
    <div
      className={
        sender
          ? "bg-dark text-white  chat-item d-flex flex-column message-width"
          : "bg-primary  bg-opacity-10  chat-item d-flex flex-column w-75 message-width"
      }
    >
      <font
        style={{ width: "fit-content" }}
        className={
          sender
            ? "bg-dark text-white px-3 py-2 chat-item text-break fold-Text-small message-width"
            : "bg-primary bg-opacity-10 px-3 py-2 chat-item text-break fold-Text-small message-content message-width"
        }
      >
        <div className="milesstone-message-bg">
          <div className="message-innerBox rounded-2 px-3 py-2">
            <div>
              A new milestone document has been uploaded. Please take a moment
              to review it.
            </div>
            <a
              onClick={reDirect}
              href=""
              className="ff-alshaus-bold text-decoration-none"
              style={{ color: "#4C56E7" }}
            >
              View Details
            </a>
          </div>
        </div>
      </font>
    </div>
  );
};
export default MilestoneDocumentUploadMessageCard;
